import styled, { css } from 'styled-components';

export const CheckboxWrapper = styled.div`
  position: relative;
  display: ${(props) => (props.inline ? 'inline-block' : 'block')};

  margin: 0 0 10px 0;

  user-select: none;
  color: ${(props) => (props.error ? props.theme.colors.danger : props.theme.colors.black)};
  font-family: ${(props) => props.theme.fonts.literata};
  font-size: 17px;
  line-height: 25px;

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  & > label {
    position: relative;
    margin-bottom: 0;
    cursor: pointer;
    min-height: 20px;
  }

  padding-left: 27px;

  & > label:before {
    content: '';
    position: absolute;
    height: 18px;
    width: 18px;
    top: 5px;
    left: -27px;
    display: block;
    background-color: ${(props) =>
      props.error ? props.theme.colors.danger80w : props.theme.colors.white};
    border: 1px solid
      ${(props) => (props.error ? props.theme.colors.danger : props.theme.colors.secondary80w)};
    border-radius: ${(props) => (props.radio ? '8px' : '2px')};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'auto')};
  }

  input:not(:disabled) {
    :hover ~ label:before {
      outline: unset;
      border: 1px solid ${(props) => props.theme.colors.primary20b};
    }

    :focus ~ label:before {
      outline: unset;
      border: 1px solid ${(props) => props.theme.colors.black};
      box-shadow: 0 0 0 1px ${(props) => props.theme.colors.white},
        0 0 0 2px ${(props) => props.theme.colors.primary};
    }

    :active ~ label:before {
      outline: unset;
      border: 1px solid ${(props) => props.theme.colors.black};
      box-shadow: 0 0 0 1px ${(props) => props.theme.colors.white},
        0 0 0 2px ${(props) => props.theme.colors.primary20b};
    }

    :checked {
      ~ label:before {
        border: 1px solid ${(props) => props.theme.colors.primary};
      }
      :hover ~ label:before {
        outline: unset;
        border: 1px solid ${(props) => props.theme.colors.black};
      }
      :focus ~ label:before {
        outline: unset;
        border: 1px solid ${(props) => props.theme.colors.primary};
        box-shadow: 0 0 0 1px ${(props) => props.theme.colors.white},
          0 0 0 2px ${(props) => props.theme.colors.primary};
      }

      :active ~ label:before {
        outline: unset;
        border: 1px solid ${(props) => props.theme.colors.primary};
        box-shadow: 0 0 0 1px ${(props) => props.theme.colors.white},
          0 0 0 2px ${(props) => props.theme.colors.primary20b};
      }
    }
  }

  input ~ .checkmark {
    pointer-events: none;
    position: absolute;
    top: 6px;
    left: 1px;
    display: none;
    height: 16px;
    width: 16px;
    z-index: 2;
    justify-content: center;
    align-items: center;
    .radio-check {
      display: block;
      height: 10px;
      width: 10px;
      border-radius: 8px;
      background-color: ${(props) => props.theme.colors.primary20b};
    }
  }

  input:checked ~ .checkmark {
    display: flex;
  }

  input:checked:disabled ~ .checkmark {
    svg {
      g {
        stroke: ${(props) => props.theme.colors.black80w};
      }
    }
    .radio-check {
      background-color: ${(props) => props.theme.colors.black80w};
    }
  }

  input:checked:disabled ~ label:before {
    cursor: not-allowed;
    background-color: ${(props) => props.theme.colors.secondary90w};
    border: 1px solid ${(props) => props.theme.colors.secondary80w};
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `}
`;
